import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import '../../../styles/assets/css/pages/form1.css'
import '../../../styles/assets/css/pages/form2.css'
import { loadLocationWithMessage } from '../../../actions/location'

import '../../../styles/assets/css/pages/stepper1.css'
import { registration_steps } from '../variables/registration.js'
import { trimonthly_steps } from '../variables/assessments.js'
import { treatment_response, yes_no} from '../variables/final_step.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepperAssm from '../assessments/stepper_assm'
import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CancelIcon from '@material-ui/icons/Cancel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { initAutosaveForForm2, ensureAutosaveInitialized, detachAutosave } from '../../utils/draftAutosaveManager'

class FinalStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
        status: 1, //false,
        status_submit: true,
        invalid: false,
        message: '',
        start_time: Math.floor(new Date().getTime()/1000),
        start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
        next_step: 'complete_assessments',
        uid: 0,
        treatment_response: -1,
        major_life_event: -1,
        major_life_event_score: 0,
        major_life_event_specify: '',
    }
    this.answerFields = [ 'treatment_response', 'major_life_event',
                          'major_life_event_score', 'major_life_event_specify', ]
    this._draft = null
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this._draft = initAutosaveForForm2(this, {
       formId: 'final_step',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    })
    var timepoint = this.props.match.params.timepoint
    if(timepoint == -1) {
      this.getRegistraionProcess()
    } else {
      this.getCompletedData(1)
    }
  }

  componentDidUpdate(prevProps) {
    ensureAutosaveInitialized(this, '_draft', {
       formId: 'final_step',
       fields: this.answerFields,
       expireMs: 10 * 24 * 60 * 60 * 1000,
    }, prevProps)
  }

  componentWillUnmount() {
    detachAutosave(this, '_draft')
  }

  getRegistraionProcess = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/registration/get_registration_process',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { uid: this.props.authReducer.uid }
    })
    .then((result) => {
        if(result['data'].reg_step !== 'final_step') {
          this.props.history.push('/member/'+result['data'].reg_step)
        }
      }
    )
  }

  handleChange3 = (e, q) => {
     const isNumeric =
       e.target.type === 'radio' ||
       e.target.type === 'number' ||
       e.target.tagName === 'SELECT';
     const value = isNumeric ? Number(e.target.value) : e.target.value;
     this.setState({ [q]: value }, () => this._draft?.saveFromState(this.state))
  }

  getCompletedData = (status) => {
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    var next_step = "complete_registration"
    if(timepoint <= -9 || timepoint > 0) {
      next_step = "complete_assessments"
    }
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: type,
        timepoint: timepoint,
        frm: 'final_step',
       }
    }).then((result) => {
      if(result['data']) {
        this.setState({
          status: status,
          next_step: next_step,
          status_submit: (result['data'].treatment_response > 0) ? false : true ,
          treatment_response: result['data'].treatment_response,
          major_life_event: result['data'].major_life_event,
          major_life_event_score: result['data'].major_life_event_score,
          major_life_event_specify: result['data'].major_life_event_specify,
        }, () => {
          this._draft?.hydrate()
        })
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var type = this.props.match.params.type
    var timepoint = this.props.match.params.timepoint
    var uri = 'patient/assessment/update_final_step'
    var next_step = 'complete_assessments'
    if((timepoint < 0 && timepoint > -9) || !timepoint || timepoint === undefined) {
      type = 'r'
      timepoint = 0
      uri = 'patient/registration/update_final_step'
      next_step = 'complete_registration'
    }

    if(this.state.status_submit) {

      if(this.state.treatment_response == -1 || this.state.major_life_event == -1
        || (this.state.major_life_event == 1 &&
           (this.state.major_life_event_score == 0 && this.state.major_life_event_specify == ''))) {
          this.setState({
            message: 'Please fill in all information.',
            invalid: true,
          })
          window.scrollTo(0, 0)
      } else {
        this.setState({
          status_submit: false,
          message: '',
        })

        axios({
          method: 'post',
          url: connectNode + uri,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
            type: type,
            timepoint: timepoint,
            next_step: next_step,
          }
        })
        .then((result) => {
          this._draft?.clear();
          if(result['data'] === 'complete_registration') {
            this.props.onLoadLocation('/member/complete_registration')
            this.props.history.push('/member/complete_registration')
          } else if(result['data'] === 'complete_assessments') {
            if(timepoint % 2 == 0) {
              var next_sixmonthly = timepoint/2
              this.props.onLoadLocation('/member/assessment/ders18/sm/'+next_sixmonthly)
              this.props.history.push('/member/assessment/ders18/sm/'+next_sixmonthly)
            } else {
              this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
              this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
            }
          }
        })
      }
    } else {
      this._draft?.clear?.();
      if(timepoint % 2 == 0) {
        var next_sixmonthly = timepoint/2
        this.props.onLoadLocation('/member/assessment/ders18/sm/'+next_sixmonthly)
        this.props.history.push('/member/assessment/ders18/sm/'+next_sixmonthly)
      } else {
        this.props.onLoadLocation('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
        this.props.history.push('/member/assessment/'+next_step+'/'+type+'/'+timepoint)
      }
    }
  }

  render() {
    const score_num = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    return (
      <div className="general_patient_information final_step box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Treatment Response and Major Life Events
          </div>
          {this.props.match.params.type != 'tm' &&
          <div className="small-12 columns stepper">
            <Stepper alternativeLabel nonLinear activeStep={11}>
              {registration_steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>}
          {this.props.match.params.type == 'tm' &&
          <StepperAssm activeStep={9} assm={'TRML'} type={this.props.match.params.type}
            status={this.state.status} timepoint={this.props.match.params.timepoint} />}
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <form id="csi" onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box2_2">
            <b>IMPORTANT: </b>
            If you cannot complete this section in one sitting, you may return and finish it <b>on this device</b> without losing your data.
          </div>
          <div className="small-12 columns">
            <div className="box_border5 p_csi">
                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">Treatment Response</div>
                    <div className="row top_space">
                      <div className="small-12 medium-8 columns">
                      {this.props.match.params.type != 'tm' && <>
                      In the past six months, how would you describe your response to your bipolar treatment?
                      (If you have not been in treatment, please select NA.) </>}
                      {this.props.match.params.type == 'tm' && <>
                      In the past three months, how would you describe your response to your bipolar treatment?</>}
                      </div>
                      <div className="small-12 medium-4 columns ">
                      <FormControl variant="outlined" >
                        <Select value={this.state.treatment_response ?? ''} variant="outlined"
                          label="" defaultValue=""
                          onChange={(e) => this.handleChange3(e, 'treatment_response')}>
                            {treatment_response.map(each =>
                              <MenuItem key={"tr"+each.value} value={Number(each.value)}>{each.label}</MenuItem>
                            )}
                        </Select>
                      </FormControl>
                      </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div className="small-12 columns ">
          <div className="box_border5 p_csi">
              <div className="row">
                <div className="small-12 columns box1">
                  <div className="title_topic1">Major Life Events</div>
                  <div className="row top_space">
                    <div className="small-12 medium-8 columns">
                    {this.props.match.params.type != 'tm' && <>
                    Have you experienced one or more major life events in the last year? Examples of a major
                    life event include loss or death of spouse, partner, child, or other close
                    family member; major health problem(s); loss of job/serious money problems;
                    moving to a new apartment/house/group home, etc.; physical or emotional abuse;
                    serious disaster or accident.</>}
                    {this.props.match.params.type == 'tm' && <>
                    Have you experienced one or more major life events in the last three months?
                    Examples of a major life event include loss or death of spouse,
                    partner, child, or other close family member; major health problem(s);
                    loss of job/serious money problems; moving to a new apartment/house/group
                    home, etc.; physical or emotional abuse; serious disaster or accident.</>}
                    </div>
                    {yes_no.map(yn =>
                    <div className="small-12 medium-2 columns ">
                      <label class="radio‐flex">
                      <input type="radio" name='major_life_event' key={"me"+yn.value}
                        value={Number(yn.value)} checked={this.state.major_life_event === Number(yn.value)}
                        onChange={(e) => this.handleChange3(e, 'major_life_event')}/>
                        <span>{yn.label}</span>
                      </label></div>)}
                  </div>
                  {this.state.major_life_event == 1 && <>
                  <div className="row top_space">
                    <div className="small-12 medium-12 columns">
                      <div className="sep_line_gen2">&nbsp;</div>
                    </div>
                    <div className="small-12 medium-8 columns">
                    How many?
                    </div>
                    <div className="small-12 medium-4 columns ">
                    <FormControl variant="outlined" >
                      <Select value={this.state.major_life_event_score ?? ''} variant="outlined"
                        label=""
                        onChange={(e) => this.handleChange3(e, 'major_life_event_score')}>
                          {score_num.map(each =>
                            <MenuItem key={"sc"+each} value={Number(each)}>{each}</MenuItem>
                          )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                  <div className="row top_space">
                    <div className="small-12 medium-8 columns">&nbsp;</div>
                    <div className="small-12 medium-4 columns stay_left">
                    <TextField name='major_life_event_specify' type='text' className="w100p"
                    value={this.state.major_life_event_specify}
                    InputProps={{ inputProps: { name: 'major_life_event_specify', maxLength: 150, placeholder: 'Please specify', }}}
                    onChange={(e) => this.handleChange3(e, 'major_life_event_specify')}
                    variant="outlined" />
                    </div>
                  </div>
                  </>}
                </div>
              </div>
          </div>
        </div>

        <div className="row">
          <div className="small-12 columns align_right">
          {(this.props.match.params.timepoint) &&
            <Button variant="contained" color="primary"
             onClick={this.handleSubmit} type="submit" className="submit_1">
              { this.state.status_submit === 1 ? 'Submit' : 'Next' }
            </Button>}
          {(!this.props.match.params.timepoint) &&
            <Button variant="contained" color="primary"
             onClick={this.handleSubmit} type="submit" className="submit_1">Submit</Button>}
          </div>
        </div>

      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(FinalStep)
